import {AppLanguageTag} from '../../i18n/types';
import i18n from 'i18next';
import {BackendLanguageTag} from '../../backend/enums/backend-language-tag';

/**
 * Get the backend language tag from the language set in the app.
 */
export const getBackendLanguageFromAppLanguage = (): BackendLanguageTag | undefined => {
  // Backend language
  let languageCode: BackendLanguageTag | undefined;

  // Get the language code
  switch (i18n.language) {
    case AppLanguageTag.ptPT:
      languageCode = BackendLanguageTag.ptPT;
      break;
    case AppLanguageTag.enUS:
      languageCode = BackendLanguageTag.enUS;
      break;
    case AppLanguageTag.esES:
      languageCode = BackendLanguageTag.esES;
      break;
    case AppLanguageTag.glES:
      languageCode = BackendLanguageTag.glES;
      break;
    case AppLanguageTag.ptBR:
      languageCode = BackendLanguageTag.ptBR;
      break;
  }

  return languageCode;
};
